import React from 'react';

export const AppContext = React.createContext('app');

// TODO: remove
export class AppContextClass extends Object {}
